<!--
 * @Author: your name
 * @Date: 2021-07-21 16:48:35
 * @LastEditTime: 2022-06-07 16:48:39
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-setting\query\list\index.vue
-->
<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SearchConfiguration.Code')" prop="indexCode">
            <BjInput
              v-model="queryParams.indexCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SearchConfiguration.Index')" prop="indexCode">
            <BjInput
              v-model="queryParams.indexCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.statusText')" prop="enabledFlag">
            <el-select
              v-model="queryParams.enabledFlag"
              class="full-width"
              :placeholder="$t('chooseText')"
              clearable
            >
              <el-option
                v-for="(item, index) in INDEXES_TYPE_LIST"
                :key="index"
                :label="$t(item.label)"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SearchConfiguration.start')">
            <BjDateTimerPicker v-model="queryParams.activeStartTime" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SearchConfiguration.end')">
            <BjDateTimerPicker v-model="queryParams.activeEndTime" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SearchConfiguration.Description')" prop="remark">
            <BjInput
              v-model="queryParams.remark"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button v-permission:SettingInquiryAdd type="primary" class="main-btn" @click="onAdd"
            >{{ $t('SearchConfiguration.New') }}</el-button
          >
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="col.prop === 'enabledFlag'"
                :type="scope.row.enabledFlag === 1 ? 'success' : 'info'"
                >{{ $t(INDEXES_TYPE_LIST.bjGet(scope.row.enabledFlag)) }}</el-tag
              >
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="props">
              <el-button
                v-permission:SettingInquiryEdit
                type="text"
                class="edit-btn"
                @click="onEdit(props.row)"
                >{{ $t('editText') }}</el-button
              >
              <el-button
                v-permission:SettingInquiry_Delete
                type="text"
                class="delete-btn"
                @click="onDelete(props.row)"
                >{{ $t('delText') }}</el-button
              >
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { settingApi } from '@/api';
import { INDEXES_TYPE_LIST } from '@/utils/constants';
const getDefaultForm = () => {
  return {};
};

export default {
  name: 'SettingInquiryIndex',
  components: {},
  mixins: [pageMiXin],
  data() {
    return {
      selection: false,
      INDEXES_TYPE_LIST,
      queryApi: settingApi.getInquiryList,
      // 查询参数
      queryParams: {
        indexCode: null,
        enabledFlag: null,
        activeStartTime: null,
        activeEndTime: null,
        remark: null,
      },
      drawer: false,
      details: {},
      // 表单参数
      form: getDefaultForm(),
      // 表单校验
      rules: {},
      labelList: [
        { label: this.$t('SearchConfiguration.Code'), prop: 'indexCode', isCheck: true, disabled: false },
        { label: this.$t('SearchConfiguration.Index'), prop: 'indexCode', isCheck: true, disabled: false },
        { label: 'table.statusText', prop: 'enabledFlag', isCheck: true, disabled: false },
        { label: this.$t('SearchConfiguration.Description'), prop: 'remark', isCheck: true, disabled: false },
        { label: this.$t('SearchConfiguration.end'), prop: 'activeEndTime', isCheck: true, disabled: false },
        { label: this.$t('SearchConfiguration.start'), prop: 'activeStartTime', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    getList() {},
    onAdd() {
      this.$router.push({
        name: 'SettingInquiryAdd',
        query: {},
      });
    },
    onEdit(row) {
      row = JSON.stringify(row);
      this.$router.push({
        name: 'SettingInquiryEdit',
        query: {
          form: row,
        },
      });
    },
    onDelete(row) {
      this.$alert(this.$t('SearchConfiguration.delete'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        callback: action => {
          if (action === 'confirm') {
            settingApi.deleteInquiry({ configId: row.configId, _token: row._token }).then(res => {
              this.msgSuccess(this.$t('toast.deleteSuccessText'));
              this.reFresh();
            });
          }
        },
      });
    },
    handleClose(done) {
      done();
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  overflow: auto;
  padding: 30px;
}
// ::v-deep .el-drawer__container ::-webkit-scrollbar{
//     display: none;
// }
</style>
